import { render, staticRenderFns } from "./HistoryBtn.vue?vue&type=template&id=43fa9032&scoped=true"
import script from "./HistoryBtn.vue?vue&type=script&lang=js"
export * from "./HistoryBtn.vue?vue&type=script&lang=js"
import style0 from "./HistoryBtn.vue?vue&type=style&index=0&id=43fa9032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fa9032",
  null
  
)

export default component.exports